import React, { useContext, useEffect, useRef, useState } from 'react';
import { Dialog, Item } from '@zebra-fed/zds-react-desktop';
import styled from 'styled-components';
import Snackbar from '@material-ui/core/Snackbar';
import {SnackbarContent} from "../../styled-components/shared";
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import { useTranslation } from "react-i18next";

import { APModel, APService} from "../../Services/AccessPointService";

import SiteFilter from "../../pages/Dashboard/SitesDashboard/Components/SiteFilter";

import { StyledField, StyledTextField, LabelText, ErrorLine, HeadDes, BodyContent } from "./Styles";

import { Formcontainer, PopupContainer, FooterContainer, PopupHeader, CheckBoxRow, TransBtn, BlueBtn } from "./Styles";



class APProps {
    
    modalRef;

    isManager;

    assignedSite;

    tenantId;

    onAccessPointAdded
}

export  function AddAccessPointModal(args) {
    
     
    var props = new APProps();
    props = args;

    const dialogRef = props.modalRef;
   
    const { t} = useTranslation();
    const [isLoading, setIsLoading] = useState(false);

    const errors = useRef([]);
    const [hasErrors, setHasErrors] = useState(false);

    const service = new APService();

    const [model, setModel] = useState({
        macAddress: "",
        friendlyName: "",
        siteName:"",
        assetName: "" 
    });
    
    const isManager = props.isManager;
    //Default site assigned if manager
    const assignedSite = props.assignedSite;
    
    const tenantId = props.tenantId;
 
    const onAccessPointAdded = props.onAccessPointAdded;

    useEffect(() => {
        clearForm();
    }, [""]);

    function clearForm() {
        
       setModel({
            macAddress: "",
            friendlyName: "",
            siteName:"",
            assetName: "" 
       });

        //Clear the errors
        errors.current = [];
    }

    function validateRequired(value, fieldName, validationMsgKey){

        if (value == null || value.trim() == "") {
            //Add the required error against the field name
            errors.current.push({"fieldName": fieldName, "errorMessage":  t(validationMsgKey)});
        }
    }

    function validateFieldLength(value, fieldName, maxLength, validationMsgKey){
     
        if(value == null || value == "") {
            //NULL value. No need for futher validation
            return;
        }

        if (value.length > maxLength) {
            //Add the MAX length Error  against the field name
            errors.current.push({"fieldName": fieldName, "errorMessage": t(validationMsgKey)});
            //errors[fieldName] = "Please provide a value with length less than " + maxLength;
        }
    }

    function validateAccessPoint(){
        errors.current = [];

        const MAX_CHARS = 32;

        const MAX_CHARS_MSG_KEY = "validation.rules.sso.rule45";
        const REQUIRED_TXT_MSG_KEY = "validation.rules.Mo_Dash.RequiredTxtMessage";
        const REQUIRED_DROPDOWN_MSG_KEY = "validation.rules.Mo_Dash.RequiredDropdownMessage";
        const EMAIL_INAVLID_KEY = "validation.rules.sso.rule46";

        
        //Validate each field
        //All the fields have the same MAX length. So use the same ERR MSG & MAX CHARS
        validateRequired(model.macAddress, "macAddress", REQUIRED_TXT_MSG_KEY);
        validateFieldLength(model.macAddress, "macAddress", MAX_CHARS, MAX_CHARS_MSG_KEY);

        validateRequired(model.friendlyName, "friendlyName", REQUIRED_TXT_MSG_KEY);
        validateFieldLength(model.friendlyName, "friendlyName", MAX_CHARS, MAX_CHARS_MSG_KEY);

        if(! isManager){
            //Site needs to be mandated only for ADMIN
            //for manager it will be automatcailly taken from his site
            validateRequired(model.siteName, "siteName", REQUIRED_DROPDOWN_MSG_KEY);
        }

        //validateRequired(model.modelNumber, "modelNumber", "maxCharsCountMsg");
        //Device friendly name is optional
        validateFieldLength(model.deviceFriendlyName, "assetName", MAX_CHARS, REQUIRED_DROPDOWN_MSG_KEY);
        //To update state for rerender
        setHasErrors(!hasErrors);
    }
 
    function getErrorMessage(field) {
        
        const error = errors.current.find((error) => error.fieldName == field);
        return error ? error.errorMessage: null;
    }



    function handleCancel() {

        //Clear the form and close it
        clearForm();
        dialogRef.current.toggleDialog();
        // clearForm();
    }

    const ButtonStyle = {
        cursor: isLoading ? 'wait' : 'pointer',
    }

    async function handleAddClick() {
        
        validateAccessPoint();
        //dialogRef.current.toggleDialog();
 
        if(errors.current.length == 0){

            setIsLoading(true);

           let APExist = await service.checkAPExist(tenantId,model.macAddress);
            console.log(APExist,'APExist')
            if(APExist.length){
                console.log('came')
                errors.current.push({"fieldName": 'macAddress', "errorMessage": t('Mo_Dash.placeholders.duplicate_AP')});
                setIsLoading(false);
                return
            }

            
            if(isManager){
                //For manager, set the site as the site assinged to him
                model.siteName = assignedSite;
            }
            //Add the AP
            await service.addAccessPoint(tenantId, model);

            //Just call the function It will take care of refreshing the UI  
            await onAccessPointAdded();
            setIsLoading(false);

             //Clear the form and close it
            clearForm();

            //close the dialog
            dialogRef.current.toggleDialog();
            
        }
    }

    return (
        <div>  
            <Dialog
                ref={dialogRef} 
                key='dialog255'
                width='520px'
                headerStyle={{ display: 'none' }}
                bodyStyle={{ padding: '0px', width: '100%' }}
                cardStyle={{ marginBottom: '80px' }} 
                footerStyle={{ display: 'none' }}> 
               
                <PopupContainer>
                <PopupHeader>{t('accessPoint.addTitle')}</PopupHeader>
                <HeadDes>{t('manual')}</HeadDes>
                <BodyContent>
                    <form noValidate onSubmit={handleAddClick}
                        style={{ pointerEvents: isLoading ? 'none' : '' }}>
                    
                        { /* If manager, don't show the site name  filter*/ }
                        {    !isManager &&
                            <div>
                            <SiteFilter siteName ={ model.siteName } onSiteSelected  = { (value) =>
                            {
                                
                                setModel({ ...model, siteName: value});
                            }} />
                            <ErrorLine style={{  display: getErrorMessage("siteName") != null ? 'block' : 'none' }}>
                            { getErrorMessage("siteName") }
                           </ErrorLine>
                           </div>
                        }
                        <Formcontainer>
                            <LabelText>{t('accessPoint.macAddress')}</LabelText>
                            <StyledTextField
                                id='outlined-basic'
                                variant="outlined"
                                error={ getErrorMessage("macAddress") }
                                onChange={(e) => setModel({ ...model, macAddress: e.target.value })}
                               
                                placeholder={t('Mo_Dash.placeholders.enter_macAddress')}
                                value={model.macAddress}
                               
                            />
                             <ErrorLine style={{  display: getErrorMessage("macAddress") != null ? 'block' : 'none' }}>
                             { getErrorMessage("macAddress") }
                            </ErrorLine>
                        </Formcontainer>
                        
                        <Formcontainer>
                            <LabelText>{t('accessPoint.assetName')}</LabelText>
                            <StyledTextField
                                id='outlined-basic'
                                variant="outlined"
                                error={ getErrorMessage("assetName") }
                                onChange={(e) => setModel({ ...model, assetName: e.target.value })}
                                placeholder={t('Mo_Dash.placeholders.enter_assetName')}
                                value={model.assetName}
                               
                            />
                             <ErrorLine style={{  display: getErrorMessage("assetName") != null ? 'block' : 'none' }}>
                             { getErrorMessage("assetName") }
                            </ErrorLine>
                        </Formcontainer>

                        <Formcontainer>
                            <LabelText>{t('accessPoint.friendlyName')}</LabelText>
                            <StyledTextField
                                id='outlined-basic'
                                variant="outlined"
                                error={ getErrorMessage("friendlyName") }
                                onChange={(e) => setModel({ ...model, friendlyName: e.target.value })}
                                placeholder={t('Mo_Dash.placeholders.enter_friendlyName')}
                                value={model.friendlyName}
                               
                            />
                             <ErrorLine style={{  display: getErrorMessage("friendlyName") != null ? 'block' : 'none' }}>
                             { getErrorMessage("friendlyName") }
                            </ErrorLine>
                        </Formcontainer>
                    </form>
                </BodyContent>

                <FooterContainer style={{ pointerEvents: isLoading ? 'none' : '' }}>
                    <TransBtn onClick={() => { handleCancel() }}>{t('cancel')}</TransBtn>
                    <BlueBtn onClick={ handleAddClick  }>{ isLoading ? t('workingOnIt') : t('Confirm')}</BlueBtn>
                </FooterContainer>
                </PopupContainer>
              
            </Dialog>
        </div>
    ) 
} 